<template>
    <div :class="{'card': offline === 0,'card card-mask': offline === 1}" @click.capture="gotoDtail">
        <avatar :url="item.logo"></avatar>
        <div class="info">
            <p class="name">{{item.name}}</p>
            <p class="id">ID: {{item.appId}}</p>
        </div>
        <div class="offline-tag" v-if="item.offline === 1">已下架</div>
        <div class="mask" v-if="item.offline === 1"></div>
    </div>
</template>
<script>
import Avatar from './Avatar.vue';
export default {
    props: {
        item: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            offline: 0
        }
    },
    components: {
        Avatar
    },
    methods: {
        gotoDtail() {
            if(this.offline === 1) {

            } else {
                window.open(location.href.replace(location.hash, '') + '#/app/setting/' + this.item.appId);
            }
        }
    },
    mounted() {
        if(this.item && this.item.offline) {
            this.offline = this.item.offline;
        }
    }
}
</script>
<style lang="less" scoped>
.card {
    position: relative;
    width: 319px;
    height: 90px;
    border: 1px solid #E0E5EC;
    border-radius: 4px;
    display: inline-block;
    vertical-align: top;
    padding: 15px 15px 0 15px;
    font-size: 0;
    .offline-tag {
        position: absolute;
        width: 42px;
        padding: 2px;
        border-radius: 2px;
        color: red;
        z-index: 1001;
        font-size: 10px;
        top: 0;
        right: 0;
        font-weight: 400;
        background: #c2c2c2;
        text-align: center;
    }
    .mask {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 888;
        background: #f5f5f5;
        filter: alpha(opacity=70);
        opacity: 0.7;
    }
    &:hover {
        cursor: default;
        border-color: #E0E5EC;
    }
    .info {
        display: inline-block;
        vertical-align: top;
        padding-top: 10px;
        margin-left: 12px;
        max-width: 243px;

        .name {
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 500;
        }
        .id {
            font-size: 14px;
            line-height: 20px;
        }
    }
    &:hover {
        cursor: pointer;
        border-color: #789AFF;
    }
    
}

&:hover {
    cursor: pointer;
    border-color: #E0E5EC;
}

</style>



// WEBPACK FOOTER //
// src/components/SmallAppCard.vue